import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.frame = requestAnimationFrame(() => {
      if (!this.element.hasAttribute("autofocus")) return

      this.element.focus({ preventScroll: true })
      const end = this.element.value.length
      this.element.setSelectionRange(end, end)
    })
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }
}
